import axios from 'axios'

export default class loginApi {
  static loginFunc(data) {
    return axios.post('/high/account/login', data)
  }

  static registFunc(data) {
    return axios.post('/high/account/regist', data)
  }

  //验证是否未注册过
  static registerCodeFunc(phone) {
    return axios.get(`/high/account/registerCode/${phone}`)
  }

  //验证是否已注册过
  static loginCodeFunc(phone) {
    return axios.get(`/high/account/loginCode/${phone}`)
  }

  //验证是否已登录
  static changeInfoCodeFunc(phone) {
    return axios.get(`/high/account/changeCode/${phone}`)
  }

  static logoutFunc() {
    return axios.post('/high/account/logout')
  }

  static updatePhone(data) {
    return axios.post('/high/account/updatePhone', data)
  }

  static updatePwd(data) {
    return axios.post('/high/account/updatePwd', data)
  }

  static ssoInfo() {
    return axios.get('/high/user/ssoInfo')
  }
}



// WEBPACK FOOTER //
// ./src/api/loginApi.js